export const getVideoCodeYoutubeFromUrl = (url) => url && url.split('v=')[1].split('&')[0];

export function getUrl(url, type_button) {
	const hasHttp = ['button', 'website', 'button_image_card', 'button_image', 'video'];
	if (!/^(http|https):\/\//g.test(url) && hasHttp.includes(type_button)) {
		return `//${url}`;
	}
	return url;
}
